import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

const LastAdminOnOrg: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box width={'100%'}>
      <Typography color='error' variant='body2'>
        You are the last Admin on the organization, you must nominate an Admin
        before removing yourself
      </Typography>
    </Box>
  );
};

export default LastAdminOnOrg;
